import React, { useEffect, useState } from 'react';
import { Card, Stack } from '@mui/material';
import { Eyebrow } from '../../pages/payroll/payrollUI';
import TrainingService, { TrainingPeriod } from '../../api/services/training.service';
import ScheduleService from '../../api/services/schedule.service';
import { useAuthStore } from '../../store/authStore';
import TrainingCard, { Person } from './TrainingCard';

// The Training section of a person's page: their newest training period,
// acted on in place. Shown to whoever runs operations; the rest of the
// person's page does not depend on it loading.
const PersonTraining: React.FC<{ accountId: string; name: string }> = ({ accountId, name }) => {
  const { canArea } = useAuthStore();
  const visible = canArea('operations', 'view');
  const editable = canArea('operations', 'edit');
  const [period, setPeriod] = useState<TrainingPeriod | null | undefined>(undefined);
  const [people, setPeople] = useState<Person[]>([]);

  useEffect(() => {
    if (!visible) return;
    TrainingService.list(accountId).then((list) => setPeriod(list.find((p) => p.status === 'active') || list[0] || null)).catch(() => setPeriod(null));
    ScheduleService.overview()
      .then((o) => setPeople((o.plan?.drivers || o.suggestions.drivers).map((d) => ({ accountId: d.accountId, name: d.name })).sort((a, b) => a.name.localeCompare(b.name))))
      .catch(() => setPeople([]));
  }, [accountId, visible]);

  if (!visible || period === undefined) return null;
  return (
    <Card sx={{ p: 2.5 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
        <Eyebrow>Training</Eyebrow>
      </Stack>
      <TrainingCard period={period} accountId={accountId} name={name} people={people} editable={editable} onChanged={setPeriod} bare />
    </Card>
  );
};

export default PersonTraining;
